module.exports = __webpack_public_path__ + "img/star-map_backgrounds-black_circle.6661e27.webp";